:host {
  display: contents;

  --content-width: var(--stzh-details-content-width, 100%);
  --content-padding-left: 0px;
  --content-padding-right: var(--stzh-details-content-padding-right, 0px);
  --content-background: transparent;
  --content-grid-column: var(--stzh-details-content-grid-column, inherit);
  --content-border-bottom: none;
  --content-padding-top: var(--stzh-details-content-padding-top, #{space('medium')});
  --content-padding-bottom: 0;

  // @include mq($from: medium) {
  //   --content-padding-top: var(--stzh-details-content-padding-top, #{spaceCurveValue('medium', 'medium')});
  // }

  // @include mq($from: large) {
  //   --content-padding-top: var(--stzh-details-content-padding-top, #{spaceCurveValue('medium', 'large')});
  // }

  // &[no-padding-top]:not([no-padding-top="false"]) {
  //   --content-padding-top: var(--stzh-details-content-padding-top, 0px);
  // }

  // &[no-padding-bottom]:not([no-padding-bottom="false"]) {
  //   --content-padding-bottom: var(--stzh-details-content-padding-bottom, 0px);
  // }
}

.stzh-details {
  &,
  &__trigger {
    display: contents;
  }

  &__content {
    width: var(--content-width);
    overflow: hidden;
    background-color: var(--content-background);
    grid-column: var(--content-grid-column);
    border-bottom: var(--content-border-bottom);

    @media print {
      height: auto !important;
      overflow: visible !important;
      display: block !important;
    }
  }

  &__content-inner {
    padding-top: var(--content-padding-top);
    padding-bottom: var(--content-padding-bottom);
    padding-left: var(--content-padding-left);
    padding-right: var(--content-padding-right);
  }
}
